<template lang="pug">
.grid-filter
  p.column-title(v-if='!params.editMode') {{ columnTitle }}
  ed-input(:placeholder='t("Search")'
          xautofocus
          v-model='text'
          search
          :ref="'input'"
  )
  ul.list(:endpoint='api.$.common.optionsFilter', :class='{ "edit": params.editMode }')
    .alert.alert-danger(v-if='errorMessage' role='alert') {{ errorMessage }}
    ed-checkbox(:options='filteredOptions' @click='click')

  ed-button.btn.btn-actionbar(@click='apply' v-if='!params.editMode') {{ t("Apply") }}
  | &nbsp;
  | &nbsp;
  a(href='#' @click.prevent='clear' v-if='!params.editMode')
    u {{ t("clear filter") }}
</template>

<script>

import {i18n} from '@/lang/lang'
import PerfectScrollbar from 'perfect-scrollbar'
import listIcons from './listIcons'

export default {
  props: ['init'],

  beforeCreate() {
    this.api = global.app.api
  },

  data() {
    return {
      options: [],
      test: '',
      formattedList: null,
      text: '',
      columnTitle: '',
      errorMessage: ''
    }
  },

  computed: {
    filteredOptions() {
      if (!this.params.editMode) this.$nextTick(this.updateScroll)
      if (this.options) {
        var ddOpt = this.options.filter(option => {
          if (this.text !== '' && this.text.trim() !== '' && this.text !== null) {
            (option.label || option.text || option.name).toLowerCase().includes(this.text.toLowerCase())
              ? option.hide = false
              : option.hide = true
          } else {
            option.hide = false
          }
          if (!this.params.editMode) {
            option.isDisabled = false
          }
          return true
        }).filter(o => !o.hasOwnProperty('hide') || (o.hasOwnProperty('hide') && o.hide === false))
        return ddOpt.slice(0, 500)
      }
    }
  },

  created() {
    this.params = this.params || this.init

    let column = this.params.colDef
    this.columnTitle = column.headerName

    this.init && this.fetchOptions()

    this.$on('showDetails', this.showDetails)
  },

  mounted() {
    //
  },

  methods: {
    showDetails(e) {
      if (e) {
        this.afterGuiAttached()
      }
    },

    afterGuiAttached() {
      this.fetchOptions()
      // if (!this.params.editMode) {
      const viewport = this.$el.querySelector('.list')
      this.ps || setTimeout(() => (this.ps = new PerfectScrollbar(viewport, { minScrollbarLength: 20 })))
      // }
    },

    t: (key) => i18n.t(key),

    clearOptions: key => (key.status = false) && 0 || key,

    getModel: function() {
      // this.text = ''
      return {
        filter: this.formattedList || this.text
      }
    },

    setModel: function(model) {
      if (model && model.filter) {
        // this.text = model.filter
        this.formattedList = model.filter
      }
      if (model === null) {
        this.text = ''
        this.formattedList = null
        this.options.forEach(option => (option.status = false))
      }
    },

    isFilterActive: function() {
      return this.text !== null &&
        this.text !== undefined &&
        this.text !== '' ||
        (this.formattedList && this.formattedList.length)
    },

    isActiveOption(option) {
      return this.formattedList.split('_').indexOf(option.label) > -1
    },

    fetchOptions() {
      let list = this
      let column = this.params.colDef
      let options = []

      if (column.options && column.options.length) {
        this.options = this.params.editMode
          ? column.options
          : column.options.map(typeof column.closeFilter === 'undefined' ? this.clearOptions : k => k)

        this.options = this.options.map(option => ({ ...option, label: option.text || option.name || option.Value || option.label || '' }))

        //
        this.options.forEach(option => {
          if (this.formattedList) {
            option.status = this.isActiveOption(option)
          }
        })
      } else {
        //
        // Fetch the options from the api
        //
        this.api.forms.post(this.api.$.common.optionsFilter, {
          grid: column.source,
          item: column.field
        }).then(r => {
          if (r) {
            let html = r.data.html
            let $list = global.jQuery(html).find('li label')

            $list.filter((k, v) => options.push({
              icon: v.getAttribute('data-icon') || (listIcons[v.innerHTML] || {}).icon,
              iconColor: v.getAttribute('data-color') || (listIcons[v.innerHTML] || {}).color,
              label: v.innerHTML,
              status: list.params.editMode
                ? (v.innerHTML === list.params.value)
                : this.getModel().filter
                  ? this.isActiveOption({ label: v.innerHTML })
                  : false
            }))

            this.options = options
            column.options = options
          } else {
            list.errorMessage = 'Try again later'
          }
        })
      }
    },

    getOptions() {
      return this.options.filter(option => option.status).map(option => option.label).join('_')
    },

    doesFilterPass: function(params) {
      return this.formattedList.split('_').filter(option =>
        option.toLowerCase() === params.data[this.params.column.colId].toLowerCase()
      ).length
    },

    apply() {
      this.formattedList = this.getOptions()
      this.params.filterChangedCallback()
    },

    clear() {
      this.setModel(null)
    },

    updateScroll() {
      this.ps && this.ps.update()
    },

    // edit
    click(e) {
      this.$emit('click', e)
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.grid-filter {
  @at-root .ag-menu:not(.ag-row-details) & {
    max-width: 220px;
    min-width: 220px;
  }

  .list.loading {
    &:before {
      top: 50%;
    }
  }
}

.list {
  list-style: none;
  padding: 0;
  min-height: 50px;
  max-height: 200px;
  overflow: auto;
  position: relative;
  margin-left: -7px;
  padding-left: 5px;
  margin-right: -7px;

  &.edit {
    //max-height: initial;
  }
  .alert {
    margin-right: 5px;
  }
}

.list >>> {
  .form-check-label.form-check-label.form-check-label {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 92%;
    .text.text.text {
      font-size: $font-size-base-sm;
      font-weight: $font-weight-normal;
      //max-width: 220px;
    }
    padding-left: 1px;
  }
  .dawn-checkbox input[type=checkbox]:focus + .check-mask {
    @include theme {
      box-shadow: none;
      border-color: v(ink);
    }
  }
  .dawn-checkbox input[type=checkbox] + .check-mask {
    margin-left: -18px;
    width: 0.95rem;
    height: 0.95rem;
    border-radius: 2px;
    @include theme { border-color: v(border) }
    &:hover {
      @include theme { border-color: v(ink) }
    }
  }
}

.form-control,
.form-group .form-control {
  @include form-field;
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/filters/list.vue